import { useEffect } from 'react'
import { useUserStore } from '@/stores/user.store'
import { setSentryUser, clearSentryUser } from '@/configs/sentry.config'
import { identifyPostHogUser, resetPostHog } from '@/configs/posthog.config'
import { setMarkerUser, unloadMarker } from '@/configs/marker.config'

/**
 * Syncs user data with monitoring tools (Sentry, PostHog, Marker.io).
 * Uses backend profile when available for accurate user identification.
 */
export function useMonitoringUser() {
  const { clerkUser, profile } = useUserStore()

  useEffect(() => {
    // Use backend profile if available, otherwise fall back to Clerk data
    if (profile) {
      // Identify with backend user ID and data
      setSentryUser({
        id: profile.id,
        email: profile.email,
        username: profile.name,
      })

      identifyPostHogUser({
        id: profile.id,
        email: profile.email,
        name: profile.name,
      })

      setMarkerUser({
        id: profile.id,
        email: profile.email,
        name: profile.name,
      })
    } else if (clerkUser) {
      // Fall back to Clerk data while backend profile is loading
      const fullName = [clerkUser.firstName, clerkUser.lastName]
        .filter(Boolean)
        .join(' ')

      setSentryUser({
        id: clerkUser.id,
        email: clerkUser.email,
        username: fullName || undefined,
      })

      identifyPostHogUser({
        id: clerkUser.id,
        email: clerkUser.email,
        name: fullName || undefined,
      })

      setMarkerUser({
        id: clerkUser.id,
        email: clerkUser.email,
        name: fullName || undefined,
      })
    } else {
      // No user - clear monitoring tool users
      clearSentryUser()
      resetPostHog()
      unloadMarker()
    }
  }, [clerkUser, profile])
}
